<div class="panel-right_overlay" (click)="close()" @panelRightFade ></div>

<div class="panel-right_container" @panelRightSlide>


  @if (isUpsertTacheVisibe) {
    <div class="panel-right_row" @toggleSlideRight>
      <app-edit-tache-form (modifier)="onTacheModifieChange($event)" (cancel)="fermerPanelModification()"
        [tache]='tacheEditee'>
      </app-edit-tache-form>
    </div>
  } @else {
    <div class="panel-right_header">
      <div class="panel-right_header_title">
        <select [(ngModel)]="tachesVisibles" (ngModelChange)="onTacheEtatVisiblesChange($event)">
          <option *ngFor="let categorie of tachesFiltering" [ngValue]="categorie">
            {{ categorie.label() }}
          </option>
        </select>

        <i class="icon icon-chevron-down"></i>
      </div>
    </div>
    <div class="panel-right_row" @toggleSlideLeft>
      <app-liste-taches [isAjoutEnabled]='true' [isModifierEnabled]='true' [isSupprimerEnabled]='true'
        [isNaviguerEnabled]='false'
        [tachesChange]='eventTachesSubject'
        (itemAModifier)='requestModification($event)' (rechargerList)="loadTaches($event)"
        (itemSupprime)="onTacheSupprimee($event)" (fermer)="close()">
      </app-liste-taches>
    </div>
  }
</div>
